import { createApp } from 'vue';

import { i18n } from 'locales';

import WebGlViewer from 'components/shared/WebGlViewer.vue';
import WebGlStatus from 'components/shared/WebGlStatus.vue';
import CanvasMiniMap from 'components/shared/CanvasMiniMap.vue';
import BoardNotesBar from 'components/boards/BoardNotesBar.vue';
import BoardInspectorControls from 'components/boards/BoardInspectorControls.vue';
import BoardInspectorLegend from 'components/boards/BoardInspectorLegend.vue';
import ProjectCheckoutButton from 'components/project/ProjectCheckoutButton.vue';

import mitt from 'mitt';

const app = createApp({
  data() {
    return {
      bus: mitt(),
      messageColor: 'white',
      message: '',
    };
  },
});
app.use(i18n);
app.component(WebGlViewer.name, WebGlViewer);
app.component(BoardInspectorControls.name, BoardInspectorControls);
app.component(BoardInspectorLegend.name, BoardInspectorLegend);
app.component(WebGlStatus.name, WebGlStatus);
app.component(CanvasMiniMap.name, CanvasMiniMap);
app.component(BoardNotesBar.name, BoardNotesBar);
app.mount('#vue-board-inspector');

const app2 = createApp();
app2.component(ProjectCheckoutButton.name, ProjectCheckoutButton);
app2.use(i18n);
app2.mount('#vue-project-checkout-button');
